<mat-card appearance="outlined" class="mat-elevation-z8" *ngIf="!orderToBeDesplayed">
  <mat-card-content class="container">
    <mat-horizontal-stepper [linear]="true" #stepper>
      <ng-template matStepperIcon="done">
        <cqes-icon icon="check"></cqes-icon>
      </ng-template>
      <ng-template matStepperIcon="edit">
        <cqes-icon icon="edit-text-success"></cqes-icon>
      </ng-template>
      <mat-step [completed]="stepOneValid">
        <ng-template matStepLabel>{{'packsTexts.choice' | translate}}</ng-template>

        <div class="container" *ngIf="packData">
          <div id="free">
            <mat-card-title>{{'packsTexts.freePack' | translate}}</mat-card-title>
            <div class="content" style="display: inline-block;">
              <ul>
                <li>{{'packsTexts.freePack1' | translate}}</li>
                <li>{{'packsTexts.freePack2' | translate}}</li>
                <li> {{'packsTexts.freePack3' | translate}}</li>
                <li> {{'packsTexts.freePack4' | translate}}</li>
                <li> {{'packsTexts.freePack5' | translate}}</li>
              </ul>
            </div>
            <div class="content" style="display: inline-block;">
              <ul>
                <li>{{'packsTexts.freePack6' | translate}}</li>
                <li>{{'packsTexts.freePack7' | translate}}</li>
                <li>{{'packsTexts.freePack8' | translate}}</li>
                <li>{{'packsTexts.freePack9' | translate}}</li>
                <li>{{'packsTexts.freePack10' | translate}}</li>
              </ul>
            </div>
          </div>

          <div class="row packs">
            <div class="single-pack" *ngFor="let pack of packData.items| slice:2:packData.items?.length">
              <cloud-pack-items [pack]="pack" (onBuyBtnClicked)="onBuyBtnClicked($event)"></cloud-pack-items>
            </div>
          </div>

        </div>
      </mat-step>
      <mat-step [completed]="stepTwoValid" matTooltip="Info about the action">
        <div class="row">
          <ng-template matStepLabel>{{'packsTexts.orderPack' | translate}}</ng-template>
          <cloud-pack-order *ngIf="isOrderStep" [selectedPack]="selectedPack" class="col s12"></cloud-pack-order>
        </div>
      </mat-step>
      <mat-step>
        <div class="row">
          <ng-template matStepLabel>{{'packsTexts.payment' | translate}}</ng-template>
          <cloud-pack-payment *ngIf="isPaymentStep" [packData]="packData" [selectedPack]="selectedPack" class="col-12">
          </cloud-pack-payment>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </mat-card-content>
</mat-card>
<div *ngIf="orderToBeDesplayed">
  <cloud-pack-payment *ngIf="packData && packData.order" [packData]="packData" [selectedPack]="selectedPack"
    class="col-12"></cloud-pack-payment>
</div>